
import { Component, Mixins, Prop } from 'vue-property-decorator';
import { VuetifyMixin, RyzerMixin, RoutingMixin } from '@/mixins';

@Component
export default class RyzerAthleteTypeCard extends Mixins(VuetifyMixin, RyzerMixin, RoutingMixin){
	@Prop({ type: Number, default: 150 }) size;
	@Prop({ type: Boolean }) noActions;
}
